import React, {useState, useRef} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {client} from '../utils/api-client'
import {useAsync} from '../utils/use-async'
import {toast} from 'react-toastify'
import {Button} from '@thryvlabs/maverick'
import CountdownTimer from './countdown-timer'
import dayjs from 'dayjs'
import OtpInput from 'react-otp-input'
import {BlueGradientBackground, ThryvLogoBlackLetters} from './AuthForm'

import '../styles/formScreensStyles.css'
import '../styles/accountDetails.css'
import {useSelector} from 'react-redux'

export const OtpContainer = ({children, className = '', ...props}) => (
  <div className={`otp-container ${className}`} {...props}>
    {children}
  </div>
)

const VerifyToken = () => {
  const [otp, setOtp] = useState('')
  const location = useLocation()
  const navigate = useNavigate()
  const params = new URLSearchParams(location.search)
  const TIMESTAMP_10_MINUTES_FROM_NOW = useRef(dayjs() + 600160)
  const id = params.get('LinkId')
  const apiURL = `keappartner/otpvalidation`
  const {run} = useAsync({
    status: 'pending',
  })

  const {isMobileViewEnable} = useSelector(state => state.screenView)

  const verifyTokenFromDB = async () => {
    try {
      //console.log(otp.join(''))
      let res = await run(client(`${apiURL}/${id}/${otp}`, {method: 'GET'}))
      if (res?.status === 200) {
        if (res?.type === '1:1' && !res?.influencerName) {
          toast.success('Your one-time code was successfully validated')
          navigate('/client-payment', {
            state: {
              id,
              linkType: res?.type,
              custEmail: res?.email,
              custThryvId: res?.thryvId,
            },
          })
        } else {
          toast.success('Your one-time code was successfully validated')
          navigate('/client-order', {
            state: {
              id,
              linkType: res?.type,
              custEmail: res?.email,
              custThryvId: res?.thryvId,
            },
          })
        }
      } else {
        toast.error('Wrong OTP . Please use correct OTP')
      }
    } catch (error) {
      toast.error(error?.message)
    }
  }

  // Router wrapper guarantees a valid LinkId; render the UI
  return (
    <>
      <BlueGradientBackground />
      <section
        className={`verify-token-container${isMobileViewEnable ? '-m' : ''}`}
      >
        <div
          className={`verify-token-card${isMobileViewEnable ? '-m' : ''} text-center`}
        >
          {isMobileViewEnable ? (
            <>
              <p className="verify-token-title-m">
                Thank you for choosing Thryv!
              </p>
              <p className="verify-token-subtitle-m">
                Protecting your account is our top priority. Please confirm your
                <br />
                account by entering the one-time code
              </p>
            </>
          ) : (
            <>
              <h2 className="verify-token-title">
                Thank you for choosing Thryv!
              </h2>
              <p className="verify-token-subtitle">
                Protecting your account is our top priority. Please confirm your
                <br />
                account by entering the one-time code
              </p>
            </>
          )}
          <section className="verify-token-header">
            <ThryvLogoBlackLetters />
          </section>
          <div>
            <OtpContainer>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span />}
                renderInput={inputProps => (
                  <input
                    {...inputProps}
                    className={`otp-input${isMobileViewEnable ? '-m' : ''}`}
                  />
                )}
                containerStyle="otp-container"
              />
            </OtpContainer>
            <CountdownTimer
              countdownTimeMS={TIMESTAMP_10_MINUTES_FROM_NOW.current}
              linkId={id}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Button
                onClick={verifyTokenFromDB}
                disabled={!otp}
                variant="primary"
                className="ad-continue ad-schedule-action"
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default VerifyToken
